import { Box, Paper, Snackbar } from '@mui/material'
import React from 'react'
import { Department } from 'enums/department'

import LoadPremixAutocomplete from 'shared/autocomplete/loadPremixAutocomplete'
import { useDispatch } from 'react-redux'
import MuiAlert from '@mui/material/Alert'

import {
  VALUE_GUDANG_RUAHAN,
  VALUE_IN,
  VALUE_OUT,
} from 'enums/stockCard'
import IncomingStockCards from './incomingStockCards'
import InventoryShell from 'components/inventory/InventoryShell'

export default function PremixInventory(props: { department: Department }) {
  const { department } = props
  const [alertMessage] = React.useState('')
  const [isSuccessSnackbarOpen, setIsSuccessSnackbarOpen] =
    React.useState(false)
  const [isFailureSnackbarOpen, setIsFailureSnackbarOpen] =
    React.useState(false)
  const [tabValue, setTabValue] = React.useState('1')

  const handleSnackbarClose = (): void => {
    setIsFailureSnackbarOpen(false)
    setIsSuccessSnackbarOpen(false)
  }

  const dispatch = useDispatch()
  React.useEffect(() => {
    const title = department
      ? `Stok Ruahan (${department.toUpperCase()})`
      : 'Stok Ruahan'
    dispatch({ type: 'SET_PAGE_TITLE', payload: title })
  }, [dispatch, department])

  return (
    <Box>
      <InventoryShell
        tabs={[
          { value: '0', label: 'Konfirmasi Kartu Stok Masuk' },
          { value: '4', label: 'Konfirmasi Kartu Stok Keluar' },
          { value: '1', label: 'Stok' },
        ]}
        tabValue={tabValue}
        onTabChange={(v) => setTabValue(v)}
      >
        {tabValue === '0' && (
          <IncomingStockCards
            type={VALUE_GUDANG_RUAHAN}
            inOutDirection={VALUE_IN}
            defaultRowsPerPage={100}
            department={department}
          />
        )}
        {tabValue === '1' && (
          <Paper>
            <Box p={2}>
              <LoadPremixAutocomplete
                loadAll
                showDetailedTable
                department={department}
                onChange={(e) => {
                  window.location.href = `/batch/inventory/${department}?premixId=${e.premixId}`
                }}
              />
            </Box>
            <Box mt={1} />
          </Paper>
        )}
        {tabValue === '4' && (
          <IncomingStockCards
            type={VALUE_GUDANG_RUAHAN}
            inOutDirection={VALUE_OUT}
            defaultRowsPerPage={100}
            department={department}
          />
        )}
      </InventoryShell>
      {/* inline expansion handled by StockCardHistory; dialog removed */}
      <Snackbar
        open={isSuccessSnackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert severity="success" elevation={6} variant="filled">
          {alertMessage}
        </MuiAlert>
      </Snackbar>
      <Snackbar
        open={isFailureSnackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert severity="error" elevation={6} variant="filled">
          {alertMessage}
        </MuiAlert>
      </Snackbar>
    </Box>
  )
}
